import React from 'react';

import PropTypes from 'prop-types';

import { AddressInput } from './address-input';
import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { FIELD_NAMES } from '../constants';

export const Line1Field = ({ optional = false }) => {
  return <AddressInput autoComplete={AutoCompleteField.AddressLine1} field={FIELD_NAMES.LINE1} optional={optional} />;
};

Line1Field.propTypes = {
  optional: PropTypes.bool,
};
